import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { timer } from 'rxjs';

export interface AccessAppPopupData {
  message: string;
  icon: string;
  height?: string;
  type: PopupType;
  method?:string;
}

export interface PopupButton {
  id: string;
  text: string;
}

export enum PopupType {
  ERROR = 'error',
  INFO = 'info',
}

@Component({
  selector: 'app-access-denied-popup',
  standalone: true,
  templateUrl: './access-denied-popup.component.html',
  styleUrls: ['./access-denied-popup.component.scss'],
})
export class AccessDeniedPopupComponent {
  buttonId: string;
  isButtonDisabled = false;
  buttonIdToDisable: string;
  urlDomain: any;
  projectId: any;
  subscription: any;
  countdown: number = 10;

  constructor(
    public dialogRef: MatDialogRef<AccessDeniedPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AccessAppPopupData,
    @Inject(MAT_DIALOG_DATA) public buttondata: PopupButton,
    private router: Router
  ) {}

  isDisabled: boolean;

  ngOnInit(): void {
    this.startCountdown();
  }

  startCountdown(): void {
    let interval = setInterval(() => {
      this.countdown -= 1;

      if (this.countdown === 0) {
        clearInterval(interval);
        window.location.href = 'https://unilever-bbfclaims.veevavault.com/';
        window.close();
      }
    }, 1000);
  }
}
